import { Field, Fieldset } from "../types";
import apiService from "../services/apiService";
import pathRoutes from "../../app/routes/pathRoutes";

export const getFieldValue = (
  fieldset: any,
  sectionName: string,
  fieldId: string
) => {
  const section = fieldset[sectionName];
  for (const item of section) {
    if (item.fields) {
      for (const field of item.fields) {
        if (field.id === fieldId) {
          return field.value || null;
        }
        if (field.conditions) {
          if (Array.isArray(field.conditions)) {
            for (const condition of field.conditions) {
              for (const conditionItem of condition.fieldset) {
                for (const nestedField of conditionItem.fields) {
                  if (nestedField.id === fieldId) {
                    return nestedField.value || null;
                  }
                }
              }
            }
          } else if ("fieldset" in field.conditions) {
            for (const conditionItem of field.conditions.fieldset) {
              for (const nestedField of conditionItem.fields) {
                if (nestedField.id === fieldId) {
                  return nestedField.value || null;
                }
              }
            }
          }
        }
      }
    }
  }
  return "";
};

export const updateValue = (
  set: string,
  fieldId: string,
  newValue: any,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  setFieldset((prevFieldset) => ({
    ...prevFieldset,
    [set]: prevFieldset[set].map((section) => ({
      ...section,
      fields: section.fields.map((field) => {
        if (field.id === fieldId) {
          return { ...field, value: newValue };
        }
        if (field.conditions) {
          const conditions = Array.isArray(field.conditions)
            ? field.conditions
            : [field.conditions];
          const updatedConditions = conditions.map((condition) => ({
            ...condition,
            fieldset: condition.fieldset.map((fieldset) => ({
              ...fieldset,
              fields: fieldset.fields.map((fieldsetField) =>
                fieldsetField.id === fieldId
                  ? { ...fieldsetField, value: newValue }
                  : fieldsetField
              ),
            })),
          }));
          return {
            ...field,
            conditions: Array.isArray(field.conditions)
              ? updatedConditions
              : updatedConditions[0],
          };
        }
        return field;
      }),
    })),
  }));
};

export const updateText = (
  set: string,
  fieldId: string,
  newValue: any,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  setFieldset((prevFieldset) => ({
    ...prevFieldset,
    [set]: prevFieldset[set].map((section) => ({
      ...section,
      fields: section.fields.map((field) =>
        field.id === fieldId ? { ...field, text: newValue } : field
      ),
    })),
  }));
};

export const updateValues = (
  fieldset: Record<string, Fieldset[]>,
  context: string,
  fieldId: string,
  newValue: any
) => {
  const updatedProcessing = (
    fields: Field[],
    parentContext: string
  ): Field[] => {
    return fields.map((field) => {
      if (field) {
        if (
          typeof field.id === "string" &&
          field.id.includes("analysis_type|") &&
          fieldId === "analysis_type"
        ) {
          const v = newValue.map((item: any) => {
            if (field.id === `${fieldId}|${item.id}`) {
              return {
                ...field,
                value: item.id,
              };
            }
            return field;
          });
          return v[0]; // Temp Alta
        } else if (
          typeof field.id === "string" &&
          field.id.includes("conditioning|") &&
          fieldId === "category"
        ) {
          if (field.label === newValue.name) {
            return {
              ...field,
              value: true,
            };
          }
          return field; // Temp Acondicionamiento
        } else if (
          typeof field.id === "string" &&
          field.id.includes("processing|") &&
          fieldId === "processing_category"
        ) {
          if (Array.isArray(newValue) && newValue.length > 0) {
            const v = newValue.map((item: any) => {
              if (field.id === `processing|${item.id}`) {
                return {
                  ...field,
                  value: true,
                };
              }
              return field;
            });
            return v[0];
          }
          return field;
        } else if (field.id === fieldId && parentContext === context) {
          return {
            ...field,
            value:
              typeof newValue === "object" &&
              Array.isArray(newValue) &&
              newValue
                ? newValue.map((val: any) => `${val.id}`)
                : typeof newValue === "object" &&
                  !Array.isArray(newValue) &&
                  newValue
                ? `${newValue.id}`
                : newValue,
          };
        } else if (field.conditions) {
          if (Array.isArray(field.conditions)) {
            return {
              ...field,
              conditions: field.conditions.map((condition) => ({
                ...condition,
                fieldset: condition.fieldset.map((set) => ({
                  ...set,
                  fields: updatedProcessing(set.fields, parentContext),
                })),
              })),
            };
          } else if ("fieldset" in field.conditions) {
            return {
              ...field,
              conditions: {
                ...field.conditions,
                fieldset: field.conditions.fieldset.map((set) => ({
                  ...set,
                  fields: updatedProcessing(set.fields, parentContext),
                })),
              },
            };
          }
        }
      }
      return field;
    });
  };

  const updatedFieldset = Object.keys(fieldset).reduce(
    (acc: Record<string, Fieldset[]>, key) => {
      acc[key] = fieldset[key].map((section: Fieldset) => ({
        ...section,
        fields: updatedProcessing(section.fields, key),
      }));
      return acc;
    },
    {}
  );
  return updatedFieldset;
};

export const updateOptions = (
  fieldset: Record<string, Fieldset[]>,
  fieldId: string,
  newOptions: any
) => {
  const updatedProcessing = (fields: Field[]): Field[] => {
    return fields.map((field) => {
      if (field) {
        if (Array.isArray(field.conditions)) {
          return {
            ...field,
            conditions: field.conditions.map((condition) => ({
              ...condition,
              fieldset: condition.fieldset.map((set) => ({
                ...set,
                fields: updatedProcessing(set.fields),
              })),
            })),
          };
        } else if (field.conditions && "fieldset" in field.conditions) {
          return {
            ...field,
            conditions: {
              ...field.conditions,
              fieldset: field.conditions.fieldset.map((set) => ({
                ...set,
                fields: updatedProcessing(set.fields),
              })),
            },
          };
        } else if (field.id === fieldId) {
          return {
            ...field,
            options: newOptions,
          };
        }
      }
      return field;
    });
  };

  const updatedFieldset = Object.keys(fieldset).reduce(
    (acc: Record<string, Fieldset[]>, key) => {
      acc[key] = fieldset[key].map((section: Fieldset) => ({
        ...section,
        fields: updatedProcessing(section.fields),
      }));
      return acc;
    },
    {}
  );
  return updatedFieldset;
};

export const updateFields = (
  fieldset: Record<string, Fieldset[]>,
  fieldId: string,
  replacements: any
) => {
  const updatedProcessing = (fields: Field[]) => {
    return fields.map((field) => {
      if (field) {
        if (typeof field.id === "string" && field.id.includes(fieldId)) {
          const replacement = replacements.find(
            (r: any) => r.label === field.label
          );
          if (replacement) {
            return {
              ...field,
              id: `${fieldId}|${replacement.value}`,
            };
          }
        }
      }
      return field;
    });
  };

  const updatedFieldset = Object.keys(fieldset).reduce(
    (acc: Record<string, Fieldset[]>, key) => {
      acc[key] = fieldset[key].map((section) => ({
        ...section,
        fields: updatedProcessing(section.fields),
      }));
      return acc;
    },
    {}
  );
  return updatedFieldset;
};

export const updateEntity = (
  fieldset: Record<string, Fieldset[]>,
  context: string,
  data: any
) => {
  if (context === "processing") {
    if (data.preparations && data.preparations.length > 0) {
      localStorage.setItem(
        "PreparationsIds",
        JSON.stringify(data.preparations)
      );
    }
  }
  if (context === "preparation") {
    let existingData = localStorage.getItem("CountingsIds"),
      parsedData: { [key: string]: { id: number }[] } = {};
    if (existingData) {
      parsedData = JSON.parse(existingData);
    }
    parsedData[`${data.id}`] = data.countings.length > 0 ? data.countings : [];
    localStorage.setItem("CountingsIds", JSON.stringify(parsedData));
  }
  if (context === "counting") {
    let existingData = localStorage.getItem("CalculationsIds"),
      parsedData: { [key: string]: { id: number }[] } = {};
    if (existingData) {
      parsedData = JSON.parse(existingData);
    }
    parsedData[`${data.id}`] =
      data.calculations.length > 0 ? data.calculations : [];
    localStorage.setItem("CalculationsIds", JSON.stringify(parsedData));
  }
  if (context === "calculation") {
    if (data.results && data.results.length > 0 && data.results[0].id) {
      localStorage.setItem("ResultsIds", `${data.results[0].id}`);
    }
  }

  Object.keys(data).map((fieldId) => {
    fieldset = updateValues(fieldset, context, fieldId, data[fieldId]);
  });
  return fieldset;
};

export const transformData = (data: any, fieldId: string) =>
  data.map((item: any) => ({
    value: `${item.id}`,
    label: transformDataLabel(item, fieldId),
    data: item,
  }));

export const transformDataLabel = (item: any, fieldId: string) => {
  let label: string = "";

  switch (fieldId) {
    case "equipment":
    case "installation":
    case "sampling_points":
    case "reason":
    case "sample_type":
    case "unit_types":
    case "laboratory":
      label = `${item.codigo} | ${item.descripcion}`;
      break;
    case "malpma_procedure":
    case "proc_take_sample":
      label = `${item.proced}`;
      break;
    case "preparation_procedure":
    case "counting_procedure":
      label = `${item.numop}`;
      break;
    case "accumulation":
      label = `${item.code} | ${item.name}`;
      break;
    case "reagent":
    case "processing_procedure":
    case "processing":
      label = `${item.name}`;
      break;
    case "analyst":
    case "retirement_analyst":
    case "masl_sampler":
    case "samples_external":
    case "reception_analyst":
      label = `${item.username}`;
      break;
    case "scintillator_lot_number":
      label = `${item.name}.${item.number_lot}`;
      break;
    default:
      label = item.descripcion;
  }
  return label;
};

export const transformDataTable = (data: any, val: boolean) => {
  const transformedDataTable = data.map((item: any) => ({
    data: item,
    id: String(item.id),
    masl_reference: item.masl_reference || "",
    client_reference: item.client_reference || "",
    installation: item.installation.descripcion || "",
    year: String(item.year),
    week: String(item.week),
    sample_type: item.sample_type.codigo || "",
    shared: item.shared ? "Si" : "No",
    accumulation: item.accumulation.code || "",
    reason: item.reason.codigo || "",
    sample_number: String(item.sample_number),
    analyst: item.analyst.email || "",
    received: /*  dayjs(item.high_date).format("DD/MM/YYYY") || "", */ "", //TODO cambiar por campo cuando se tenga el campo en la API
    sampling: item.sampling ? item.sampling.id : "",
    sampleManagement: item.sampleManagement ? item.sampleManagement.id : "",
    conditioning: item.conditioning ? item.conditioning.id : "",
    processing: item.processing ? item.processing.id : "",
    analysis: item.analysis_type ? item.analysis_type[0]?.descripcion : "",
    analysis_type: item.analysis_type ? item.analysis_type[0]?.id : "",
    sampling_point: item.sampling_points
      ? item.sampling_points.descripcion
      : "",
    sampling_points: item.sampling_points ? item.sampling_points.codigo : "",
    preparation: "",
    preparations: [],
    counting: "",
    countings: {},
    calculation: "",
    calculations: {},
    results: "",
  }));
  let maslReference = data.map((item: any) => ({
    value: item.masl_reference || "",
    label: item.masl_reference || "",
  }));
  maslReference = maslReference.filter(
    (obj: any, index: any, self: any) =>
      index === self.findIndex((t: any) => t.value === obj.value)
  );
  let clientReference = data.map((item: any) => ({
    value: item.client_reference || "",
    label: item.client_reference || "",
  }));
  clientReference = clientReference.filter(
    (obj: any, index: any, self: any) =>
      index === self.findIndex((t: any) => t.value === obj.value)
  );
  localStorage.setItem("maslReferenceList", JSON.stringify(maslReference));
  localStorage.setItem("clientReferenceList", JSON.stringify(clientReference));
  if (val)
    localStorage.setItem("AltaIds", `${transformedDataTable.length + 1}`);

  return val
    ? transformedDataTable.sort((a: any, b: any) => b.id - a.id)
    : transformedDataTable[0];
};

export const getData = async (
  endpoint: string,
  fieldId: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>,
  order?: string
) => {
  const response = await apiService<{ message: string; data: any[] }>({
    endpoint,
    method: "GET",
  });

  if (response.success) {
    let data = response.data;

    if (order) {
      data = data.sort((a: any, b: any) => {
        if (a[order] < b[order]) return -1;
        if (a[order] > b[order]) return 1;
        return 0;
      });
    }

    const transformedData = transformData(data, fieldId);
    setFieldset((prevFieldset) =>
      updateOptions(prevFieldset, fieldId, transformedData)
    );
  }
};
export const getDataFields = async (
  endpoint: string,
  fieldId: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "GET",
  });

  if (response.success) {
    const transformedData = transformData(response.data, fieldId);
    setFieldset((prevFieldset) =>
      updateFields(prevFieldset, fieldId, transformedData)
    );
  }
};

export const getDataTable = async (
  endpoint: string,
  setDataTable: React.Dispatch<React.SetStateAction<any>>
) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "GET",
  });

  if (response.success) {
    setDataTable(
      transformDataTable(
        Array.isArray(response.data) ? response.data : [response.data],
        Array.isArray(response.data)
      )
    );
  }
};

export const getDataEntity = async (
  context: string,
  endpoint: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>,
  recharge: boolean = false
) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "GET",
  });

  if (response.success) {
    setFieldset((prevFieldset) =>
      updateEntity(prevFieldset, context, response.data)
    );
    return response.data;
  } else {
    if (recharge)
      window.open(pathRoutes.PORTAL_SAMPLES, "_self", "noopener,noreferrer");
  }
};

export const fetchAllData = async (fetchFunctions: Promise<void>[]) => {
  await Promise.all(fetchFunctions);
};

export const disableFields = (
  fieldsetKey: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  setFieldset((prevState) => {
    const updatedFields = prevState[fieldsetKey].map((section) => {
      const updatedSection = {
        ...section,
        fields: section.fields.map((field) => ({
          ...field,
          disabled: true,
        })),
      };
      return updatedSection;
    });

    return {
      ...prevState,
      [fieldsetKey]: updatedFields,
    };
  });
};

export const updateFieldProperty = (
  set: string,
  fieldId: string,
  propertyToUpdate: string,
  newValue: any,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  setFieldset((prevFieldset) => ({
    ...prevFieldset,
    [set]: prevFieldset[set].map((section) => ({
      ...section,
      fields: section.fields.map((field) => {
        if (field.id === fieldId) {
          return { ...field, [propertyToUpdate]: newValue };
        }
        if (field.conditions) {
          const conditions = Array.isArray(field.conditions)
            ? field.conditions
            : [field.conditions];
          const updatedConditions = conditions.map((condition) => ({
            ...condition,
            fieldset: condition.fieldset.map((fieldset) => ({
              ...fieldset,
              fields: fieldset.fields.map((fieldsetField) =>
                fieldsetField.id === fieldId
                  ? { ...fieldsetField, [propertyToUpdate]: newValue }
                  : fieldsetField
              ),
            })),
          }));
          return {
            ...field,
            conditions: Array.isArray(field.conditions)
              ? updatedConditions
              : updatedConditions[0],
          };
        }
        return field;
      }),
    })),
  }));
};

export const getDataScintillator = async (
  endpoint: string,
  fieldId: string,
  setFieldset: React.Dispatch<React.SetStateAction<Record<string, Fieldset[]>>>
) => {
  const response = await apiService<{ message: string }>({
    endpoint,
    method: "GET",
  });

  if (response.success && response.data) {
    const filterResponse = response?.data?.filter(
      (item: any) => item.end_date_use === null
    );
    const transformedData = transformData(filterResponse, fieldId);
    setFieldset((prevFieldset) =>
      updateOptions(prevFieldset, fieldId, transformedData)
    );
  }
};
